export const singleStaffInformation =[
    {
      id:'1',
      fieldName:'Email',
      typeInformation:'email'
    },
    {
      id:'2',
      fieldName:'Phone',
      typeInformation:'phone'

    }
  ]